const data = [
  {
    title: "Scroll To Top/Bottom",
    shortDescription:
      "The 'Fast Travel' buttons. Instantly jump to the very start or end of a long page without dragging the scrollbar.",
    description:
      "This project teaches you how to control the browser window using JavaScript. It is really simple geometry. To go to the top, we tell the window to move to pixel '0' (the start). To go to the bottom, we calculate the total height of your page (`scrollHeight`) and tell the window to go there. We also add the `behavior: 'smooth'` property, which turns a jarring jump into a nice, smooth glide.",
  },
];

export default data;